<div class="shoe-card">
    <h3 tabindex="0">{{shoe.name}}</h3>
    <img src="{{shoe.img}}" class="img-responsive" alt="picture of the {{shoe.name}}" width = "100%" tabindex="0">
    <ul tabindex="0">
        <li>Weight: {{shoe.weight}}oz</li>
        <li>Heel stack height: {{shoe.heelStack}}mm</li>
        <li>Forefoot stack height: {{shoe.forefootStack}}mm</li>
        <li>Heel-to-toe drop: {{shoe.heelToToeDrop}}mm</li>
    </ul>
</div>